import { Box, useTheme } from "@mui/material";
import { FC } from "react";
import parse from "html-react-parser";

interface NotificationPreviewProps {
  notificationHtml: string;
  backgroundColor?: string;
  height?: number;
  width?: number | string;
}

const NotificationPreview: FC<NotificationPreviewProps> = ({
  notificationHtml,
  backgroundColor,
  height,
  width,
}) => {
  const theme = useTheme();
  return (
    <Box
      id='notification-preview'
      style={{
        width: width ?? "auto",
        backgroundColor: backgroundColor
          ? backgroundColor
          : theme.palette.natural.t9,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {parse(notificationHtml)}
    </Box>
  );
};

export default NotificationPreview;
